export const basicGeoSourceJson = {
    type: 'geojson',
    data: {
        type: 'FeatureCollection',
        features: [{
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: []
                },
                properties: {}
            }]
    }
};
export const baseLineLayer = (layerId, source) => {
    return {
        id: layerId,
        type: 'line',
        source,
        'layout': {
            'line-join': 'round',
            'line-cap': 'round'
        },
    };
};
export const baseLineSource = (points) => {
    return {
        type: 'FeatureCollection',
        features: [{
                type: 'Feature',
                geometry: {
                    type: 'LineString',
                    coordinates: points
                },
                properties: {}
            }]
    };
};
